import React from 'react'
import PropTypes from 'prop-types'
import PackageBuilderHelper from '../../../../../package-builder-helper'

const MultiPoseBuilder = ({ placeholder, checkForeground = true, images, imageTypes, option, prefilledSheets, selectedPackage, onComplete, backgrounds, checkBackgrounds = true }) => {

  return (
    <PackageBuilderHelper
      placeholder={placeholder}
      checkForeground={checkForeground}
      poses
      studentImages={images}
      backgrounds={backgrounds}
      sheetList={imageTypes}
      prefilledSheets={prefilledSheets}
      onComplete={onComplete}
      selectedPackage={selectedPackage}
      initialIndex={0}
      selectedOption={option}
      maxPoses={option.digitalImagesOnly ? Infinity : option.poses}
      checkBackgrounds={checkBackgrounds}
    />
  )
}

MultiPoseBuilder.propTypes = {
  backgrounds: PropTypes.array,
  images: PropTypes.array,
}

MultiPoseBuilder.defaultProps = {
  backgrounds: [],
  images: [],
}

export default MultiPoseBuilder
